import * as ActionType from '../../constants/actionType';

const initialState = {
  deviceSerialNumber: 'FAST-001',
  softwareVersion: '2.0.0',
  softwareInstalledDate: new Date(),
  prevSWVersion: '1.0.0',
  prevSWInstalledDate: new Date(),
  instrumentControlVersion: '1.0.0',
  firmwareChassisVersion: '1.0.0',
  firmwareHeadVersion: '1.0.0',
  firmwareWeightScaleVersion: '1.0.0',
  visionVersion: '1.0.0',
  labwareVersion: '1.0.0',
  IPAddress: '10.200.1.139',
  isUpdating: false,
  isDowngrading: false,
  isFinalizing: false,
  isDowngradable: false,
  fastInstrumentType: '2',
  tipPlungerUsageCycle: 0,
};

// eslint-disable-next-line default-param-last
export default function aboutState(state = initialState, action) {
  switch (action.type) {
    case ActionType.SET_SYSTEM_INFORMATION_DATA:
      return {
        ...state,
        deviceSerialNumber: action.data.serialNumber,
        softwareVersion: action.data.softwareVersion,
        softwareInstalledDate: action.data.softwareInstalledDate,
        softwareReleaseDate: action.data.softwareReleaseDate,
        prevSWVersion: action.data.softwarePreviousVersion,
        prevSWInstalledDate: action.data.softwarePreviousInstalledDate,
        prevSWReleaseDate: action.data.softwarePreviousReleaseDate,
        instrumentControlVersion: action.data.instrumentControlVersion,
        firmwareChassisVersion: action.data.firmwareChassisVersion,
        firmwareHeadVersion: action.data.firmwareHeadVersion,
        firmwareWeightScaleVersion: action.data.firmwareWeightScaleVersion,
        visionVersion: action.data.visionVersion,
        labwareVersion: action.data.labwareVersion,
        IPAddress: action.data.ipAddress,
        isDowngradable: action.data.isDowngradable,
        fastInstrumentType: action.data.fastInstrumentType,
        tipPlungerUsageCycle: action.data.tipPlungerUsageCycle,
      };
    case ActionType.SET_IS_UPDATING:
      return {
        ...state,
        isUpdating: action.isUpdating,
      };
    case ActionType.SET_IS_DOWNGRADING:
      return {
        ...state,
        isDowngrading: action.isDowngrading,
      };
    case ActionType.SET_IS_FINALIZING:
      return {
        ...state,
        isFinalizing: action.isFinalizing,
      };
    default:
      return state;
  }
}
